const DbCollections = {
    AdditionalStages: 'additionalStages',
    AdditionalExercises: 'additionalExercises',
    ChatSchedule: 'chatSchedule',
    Content: 'content',
    Exercises: 'exercises',
    ExternalContent: 'externalContent',
    ExternalContentCategories: 'externalContentCategories',
    Languages: 'languages',
    Missions: 'missions',
    Stages: 'stages',
    Rewards: 'rewards',
    Settings: 'settings',
    Skills: 'skills',
    TaskTypes: 'taskTypes',
    Tasks: 'tasks',
    Options: 'options',
    Users: 'users',
    Documents: 'documents',
    Coach: 'coach',
    Meetings: 'meetings',
    Payments: 'payments',
} as const;

export default DbCollections;
